import { CALLMEBACK_EVENT, EVENT_CLICK } from 'Tracking/constants';

export const mapFooterIconsToContactsBarTypes = {
  callMeBack: 'phone',
  phoneBubble: 'phone',
  storeLocator: 'storeLocator',
  faq: 'askQuestions',
  termsAndConditions: 'warning',
  mobileApp: 'smartphone',
  mail: 'mail',
};

export const getDetailClickEventTrackingData = (type, href) => {
  const eventClick = { ...EVENT_CLICK };
  const isWhatsapp = href?.hostname?.()?.includes('whatsapp');

  eventClick.callMeBack = isWhatsapp ? CALLMEBACK_EVENT.whatsapp : CALLMEBACK_EVENT.phone;

  return eventClick[type];
};
